import { Button } from '../../components/Button/NewButton';
import { useOperator } from '../../contexts/OperatorContext';
import clsx from 'clsx';
import { useUser } from '../../contexts/UserContext';
import { useCitrusView } from '../../contexts/CitrusViewContext';
import { useDeviceState } from '../../hooks/DeviceState/queries';
import { getDeviceStateText } from '../../hooks/DeviceState/adapters';

type Props = {
  device: Device;
  onDeselect?(): void;
  onSelect?(): void;
};

export const DeviceOption = ({ device, onDeselect, onSelect }: Props) => {
  const operator = useOperator();
  const { connectedUser } = useCitrusView();

  const deviceId = operator.type === 'Residential' ? device?.mac : device?.id;
  const state = useDeviceState('QASTN', deviceId, 'MediaRoom Set-Top Box');
  const { email } = useUser();
  const disabled = connectedUser !== email;

  const deviceStateText = getDeviceStateText(state.data);

  return (
    <li className="flex grow items-center justify-between gap-2 px-4 py-2">
      <div className="flex gap-2 items-center">
        <div className="relative flex items-center justify-center h-3 w-3">
          <div
            className={clsx('w-3 h-3 rounded-full', {
              'bg-green-500 after:w-3 after:h-3 after:animate-ping after:inset-0 after:bg-green-500 after:rounded-full':
                deviceStateText === 'Online',
              'bg-red-500': deviceStateText === 'Offline',
              'bg-amber-500': deviceStateText === 'Partially Online',
              'bg-gray-200': state.isFetching,
            })}
          />
        </div>
        <p>
          {device.location} ({device.id.substring(device.id.length - 5)})
        </p>
      </div>
      {onSelect !== undefined && (
        <Button
          theme="text"
          typeCasing="capitalize"
          onClick={onSelect}
          disabled={disabled}
        >
          Select
        </Button>
      )}
      {onDeselect !== undefined && (
        <Button
          theme="text"
          typeCasing="capitalize"
          onClick={onDeselect}
          disabled={disabled}
        >
          Deselect
        </Button>
      )}
    </li>
  );
};
